import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";

import "../styles/header.css";

function Header() {
  return (
    <Navbar expand="lg" className="header" fixed="top" variant="dark">
      <Container>
        <Navbar.Brand href="#home">
          <img src="chEcs-logo.png" alt="logo" width={"40"} height={"40"} />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link href="#home">
              <span className="header-link">Home</span>
            </Nav.Link>
            <Nav.Link href="#about">
              <span className="header-link">About us</span>
            </Nav.Link>
            <Nav.Link href="#infrastructure">
              <span className="header-link">Infrastructure</span>
            </Nav.Link>
            <Nav.Link href="#services">
              <span className="header-link">Services</span>
            </Nav.Link>
            <Nav.Link href="#contact">
              <span className="header-link">Contact</span>
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Header;
